<button (click)="checkLetter()" class="bg-white text-Dark-Navy w-full heading-xs py-[10px] px-[9px] rounded-lg"
  [ngClass]="{'opacity-20 pointer-events-none': disabled}">
  {{letter}}
</button>
